/**
 * VV back-in-stock alert.
 * - <vv-notify> shows "Notify me when available" while the chosen size is sold out.
 * - The popup (built on first open, blurred background) asks for the size and an email address.
 * - Requests go to the Best Delivery worker; Shopify emails the customer when the size is back.
 */
const EMAIL_KEY = 'vv_notify_email';
const EMAIL_RE = /^[^\s@<>()"',;:]+@[^\s@<>()"',;:]+\.[A-Za-z]{2,}$/;
const ICON_X =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
const ICON_DOWN =
  '<svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 1.5l5 5 5-5"/></svg>';
const ICON_OK =
  '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="20" cy="20" r="18.5"/><path d="M12.5 20.5l5 5 10-11"/></svg>';

const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const store = {
  get() {
    try {
      return localStorage.getItem(EMAIL_KEY) || '';
    } catch (e) {
      return '';
    }
  },
  set(v) {
    try {
      localStorage.setItem(EMAIL_KEY, v);
    } catch (e) {}
  },
};

function injectStyles() {
  if (document.getElementById('vv-nm-styles')) return;
  const s = document.createElement('style');
  s.id = 'vv-nm-styles';
  s.textContent = `
  .vv-nm{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:#000;-webkit-font-smoothing:antialiased}
  .vv-nm[hidden]{display:none}
  .vv-nm__veil{position:absolute;inset:0;background:rgba(0,0,0,.2);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);opacity:0;transition:opacity .45s ease}
  .vv-nm__panel{position:relative;width:100%;max-width:440px;max-height:calc(100dvh - 32px);overflow:auto;background:#fff;opacity:0;transform:translateY(16px);transition:opacity .4s ease,transform .5s cubic-bezier(.2,.8,.2,1)}
  .vv-nm.is-open .vv-nm__veil{opacity:1}
  .vv-nm.is-open .vv-nm__panel{opacity:1;transform:none}
  .vv-nm__head{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:54px;padding:0 16px 0 20px;border-bottom:1px solid #e3e3e3}
  .vv-nm__title{margin:0;font-size:13px;font-weight:700;letter-spacing:.02em;text-transform:uppercase}
  .vv-nm__close{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;margin-right:-8px;padding:0;border:0;background:none;color:#000;cursor:pointer}
  .vv-nm__close svg{width:18px;height:18px}
  .vv-nm__body{padding:20px 20px 22px}
  .vv-nm__text{margin:0 0 18px;font-size:13px;line-height:1.5;color:#4a4a4a}
  .vv-nm__product{display:flex;align-items:center;gap:12px;margin:0 0 18px}
  .vv-nm__thumb{flex:0 0 54px;width:54px;aspect-ratio:4/5;background:#f5f5f5 center/cover no-repeat}
  .vv-nm__name{margin:0;font-size:12px;font-weight:700;line-height:1.3;text-transform:uppercase}
  .vv-nm__label{display:block;margin:0 0 6px;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#6b6b6b}
  .vv-nm__select{position:relative;margin-bottom:14px}
  .vv-nm__select select,.vv-nm__email{display:block;width:100%;height:46px;margin:0;padding:0 14px;border:1px solid #d6d6d6;border-radius:0;background:#fff;color:#000;font:inherit;font-size:16px;-webkit-appearance:none;appearance:none;box-shadow:none;outline:none;transition:border-color .2s ease}
  .vv-nm__select select{padding-right:40px;cursor:pointer;text-transform:uppercase}
  .vv-nm__select svg{position:absolute;top:50%;right:14px;width:12px;height:8px;margin-top:-4px;pointer-events:none}
  .vv-nm__select select:focus,.vv-nm__email:focus{border-color:#000}
  .vv-nm__email.is-invalid{border-color:#b3202a}
  .vv-nm__trap{position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0}
  .vv-nm__check{display:flex;align-items:flex-start;gap:10px;margin:16px 0 0;font-size:12px;line-height:1.45;color:#4a4a4a;cursor:pointer}
  .vv-nm__check input{flex:0 0 16px;width:16px;height:16px;margin:1px 0 0;accent-color:#000;cursor:pointer}
  .vv-nm__error{margin:12px 0 0;font-size:12px;color:#b3202a}
  .vv-nm__error[hidden]{display:none}
  .vv-nm__submit{display:flex;align-items:center;justify-content:center;width:100%;height:50px;margin-top:18px;border:0;border-radius:0;background:#111;color:#fff;font:inherit;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:opacity .2s ease}
  .vv-nm__submit:hover{opacity:.88}
  .vv-nm__submit[disabled]{opacity:.6;cursor:default}
  .vv-nm__note{margin:12px 0 0;font-size:11px;line-height:1.4;color:#8a8a8a;text-align:center}
  .vv-nm__done{padding:34px 24px 28px;text-align:center}
  .vv-nm__done[hidden]{display:none}
  .vv-nm__done svg{width:44px;height:44px;margin-bottom:14px}
  .vv-nm__done-title{margin:0 0 8px;font-size:14px;font-weight:700;text-transform:uppercase}
  .vv-nm__done-text{margin:0 0 22px;font-size:13px;line-height:1.5;color:#4a4a4a}
  @media (max-width:749px){
    .vv-nm{align-items:flex-end;padding:0}
    .vv-nm__panel{max-width:none;max-height:92dvh;transform:translateY(100%);padding-bottom:env(safe-area-inset-bottom,0px)}
  }
  @media (prefers-reduced-motion:reduce){.vv-nm__veil,.vv-nm__panel{transition:none}}
  `;
  document.head.appendChild(s);
}

const popup = {
  el: null,
  owner: null,
  lastFocus: null,
  timer: 0,
  build() {
    if (this.el) return this.el;
    injectStyles();
    const el = document.createElement('div');
    el.className = 'vv-nm';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'vv-nm-title');
    el.innerHTML =
      '<div class="vv-nm__veil" data-vv-nm-close></div>' +
      '<div class="vv-nm__panel" tabindex="-1">' +
      '<div class="vv-nm__head"><p class="vv-nm__title" id="vv-nm-title">Notify me when available</p>' +
      '<button type="button" class="vv-nm__close" data-vv-nm-close aria-label="Close">' + ICON_X + '</button></div>' +
      '<form class="vv-nm__body" novalidate>' +
      '<p class="vv-nm__text">This size is sold out. Leave your email and we’ll let you know as soon as it’s back in stock.</p>' +
      '<div class="vv-nm__product"><span class="vv-nm__thumb" data-vv-nm-thumb></span><p class="vv-nm__name" data-vv-nm-name></p></div>' +
      '<div data-vv-nm-size-wrap><label class="vv-nm__label" for="vv-nm-size">Size</label>' +
      '<div class="vv-nm__select"><select id="vv-nm-size" name="variant"></select>' + ICON_DOWN + '</div></div>' +
      '<label class="vv-nm__label" for="vv-nm-email">Email</label>' +
      '<input class="vv-nm__email" id="vv-nm-email" type="email" name="email" autocomplete="email" inputmode="email" placeholder="Email address" required>' +
      '<input class="vv-nm__trap" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<label class="vv-nm__check"><input type="checkbox" name="consent"><span>Don’t miss a drop: send me new arrivals and member-only offers by email.</span></label>' +
      '<p class="vv-nm__error" role="alert" hidden></p>' +
      '<button type="submit" class="vv-nm__submit">Notify me</button>' +
      '<p class="vv-nm__note">One email when it’s back. We never share your email.</p>' +
      '</form>' +
      '<div class="vv-nm__done" hidden>' + ICON_OK +
      '<p class="vv-nm__done-title">You’re on the list</p><p class="vv-nm__done-text" data-vv-nm-done></p>' +
      '<button type="button" class="vv-nm__submit" data-vv-nm-close>Continue shopping</button></div>' +
      '</div>';
    el.addEventListener('click', (e) => {
      if (e.target.closest('[data-vv-nm-close]')) this.close();
    });
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
    el.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
    el.querySelector('.vv-nm__email').addEventListener('input', (e) => e.target.classList.remove('is-invalid'));
    document.body.appendChild(el);
    this.el = el;
    return el;
  },
  open(owner) {
    const el = this.build();
    clearTimeout(this.timer);
    this.owner = owner;
    this.lastFocus = document.activeElement;
    const data = owner.data;
    const current = owner.currentVariant();
    const form = el.querySelector('form');
    form.hidden = false;
    el.querySelector('.vv-nm__done').hidden = true;
    el.querySelector('.vv-nm__error').hidden = true;
    el.querySelector('[data-vv-nm-name]').textContent = data.title || '';
    const thumb = el.querySelector('[data-vv-nm-thumb]');
    const img = owner.image();
    thumb.style.backgroundImage = img ? 'url("' + img.replace(/"/g, '%22') + '")' : '';
    thumb.hidden = !img;

    // Sizes of the same colour / options as the chosen variant; only sold-out ones can be picked.
    const si = Number(data.size);
    const same = (data.variants || []).filter((v) =>
      !current || v.o.every((o, i) => i === si || o === current.o[i])
    );
    const select = el.querySelector('select');
    select.innerHTML = same
      .map((v) => {
        const label = si >= 0 ? v.o[si] : v.t;
        return '<option value="' + v.id + '"' + (v.a ? ' disabled' : '') + (current && v.id === current.id ? ' selected' : '') + '>' +
          esc(label) + (v.a ? ' – in stock' : '') + '</option>';
      })
      .join('');
    if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
      const firstOut = same.find((v) => !v.a);
      if (firstOut) select.value = String(firstOut.id);
    }
    el.querySelector('[data-vv-nm-size-wrap]').hidden = same.length <= 1 || (data.variants || []).length <= 1;

    const email = el.querySelector('.vv-nm__email');
    if (!email.value) email.value = store.get();
    email.classList.remove('is-invalid');

    const sbw = window.innerWidth - document.documentElement.clientWidth;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (el.hidden) return;
        el.classList.add('is-open');
        (email.value ? el.querySelector('.vv-nm__submit') : email).focus({ preventScroll: true });
      })
    );
  },
  close() {
    const el = this.el;
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      el.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = '';
    }, 420);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  },
  error(text) {
    const p = this.el.querySelector('.vv-nm__error');
    p.textContent = text;
    p.hidden = false;
  },
  async submit() {
    const el = this.el;
    const owner = this.owner;
    const form = el.querySelector('form');
    const btn = form.querySelector('.vv-nm__submit');
    const emailInput = form.email;
    const email = emailInput.value.trim();
    el.querySelector('.vv-nm__error').hidden = true;
    if (!EMAIL_RE.test(email)) {
      emailInput.classList.add('is-invalid');
      emailInput.focus();
      return this.error('Please enter a valid email address.');
    }
    const variant = form.variant.value || (owner.currentVariant() || {}).id;
    if (!variant) return this.error('Please choose a size.');
    const consent = form.consent.checked;
    btn.disabled = true;
    btn.textContent = 'Sending…';
    try {
      const res = await fetch(owner.dataset.endpoint.replace(/\/+$/, '') + '/restock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, variant, handle: owner.dataset.handle, consent, website: form.website.value }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        this.error(data.error || 'Something went wrong. Please try again.');
        return;
      }
      store.set(email);
      if (consent) subscribeNewsletter(email);
      const opt = form.variant.selectedOptions[0];
      const size = opt && el.querySelector('[data-vv-nm-size-wrap]').hidden === false ? opt.textContent : '';
      el.querySelector('[data-vv-nm-done]').innerHTML =
        'We’ll email <b>' + esc(email) + '</b> as soon as ' + (size ? 'size <b>' + esc(size) + '</b>' : 'it') + ' is back in stock.';
      form.hidden = true;
      el.querySelector('.vv-nm__done').hidden = false;
      el.querySelector('.vv-nm__done .vv-nm__submit').focus({ preventScroll: true });
    } catch (e) {
      this.error('No connection. Please try again.');
    } finally {
      btn.disabled = false;
      btn.textContent = 'Notify me';
    }
  },
};

// Optional newsletter sign-up through Shopify's own customer form (same as the footer sign-up).
function subscribeNewsletter(email) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const body = new URLSearchParams({
    form_type: 'customer',
    utf8: '✓',
    'contact[email]': email,
    'contact[tags]': 'newsletter,back-in-stock',
  });
  fetch(root + 'contact', { method: 'POST', body, headers: { Accept: 'text/html' } }).catch(() => {});
}

class VVNotify extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    try {
      this.data = JSON.parse(this.querySelector('[data-vv-notify-data]').textContent);
    } catch (e) {
      this.data = { variants: [] };
    }
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-vv-notify-open]')) {
        e.preventDefault();
        popup.open(this);
      }
    });
    this._onVariant = (e) => {
      const r = e.detail && e.detail.resource;
      if (r && r.id) this.update(r.id, r.available);
      else this.refreshSoon();
    };
    this._onChange = (e) => {
      if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker, [data-vv-vp]')) this.refreshSoon();
    };
    document.addEventListener('variant:update', this._onVariant);
    document.addEventListener('change', this._onChange);
    this.refresh();
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariant);
    document.removeEventListener('change', this._onChange);
    this._bound = false;
  }

  form() {
    const block = this.closest('.buy-buttons-block') || document;
    return block.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
  }

  currentVariant() {
    const f = this.form();
    const id = f && f.querySelector('[name="id"]') ? Number(f.querySelector('[name="id"]').value) : 0;
    const list = this.data.variants || [];
    return list.find((v) => v.id === id) || (list.length === 1 ? list[0] : null);
  }

  image() {
    const img = document.querySelector('.product-media img, .product__media img, media-gallery img, [data-media-id] img');
    return img ? img.currentSrc || img.src : '';
  }

  update(id, available) {
    const v = (this.data.variants || []).find((x) => x.id === Number(id));
    if (v && typeof available === 'boolean') v.a = available;
    const show = v ? !v.a : false;
    if (this.hidden === show) this.hidden = !show;
  }

  refresh() {
    const v = this.currentVariant();
    if (v) this.update(v.id);
  }

  refreshSoon() {
    clearTimeout(this._t);
    this._t = setTimeout(() => this.refresh(), 60);
  }
}

if (!customElements.get('vv-notify')) customElements.define('vv-notify', VVNotify);
